import { Breakpoints } from '@volkswagen-onehub/components-core';
import styled from 'styled-components';
import { VWTheme } from '../../shared/typings/vw-theme';

interface BackgroundWrapperProps {
  backgroundImages?: {
    mobile: string;
    tablet: string;
    desktop: string;
  };
}

export const StyledLoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: baseline;
  height: calc(100vh - 48px);
  width: 100%;
  margin-top: -56px;
  margin-bottom: -56px;

  @media (min-width: ${Breakpoints.b1280}px) {
    margin-top: -92px;
    margin-bottom: -92px;
  }

  @media (min-width: ${Breakpoints.b1600}px) {
    width: 100vw;
    flex-direction: row;
  }
`;

export const StyledBackgroundWrapper = styled.div<BackgroundWrapperProps>`
  flex: 1;
  background: ${(theme: VWTheme) =>
    theme?.colors?.content?.tertiary || ' #3c484d'}; /* fallback color */
  margin-bottom: 48px;
  width: 100vw;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  /* Mobile background image (default, up to 560px) */
  ${({ backgroundImages }) =>
    backgroundImages?.mobile &&
    `
      background-image: url('${backgroundImages.mobile}');
      background-color: transparent;
    `}

  @media (min-width: ${Breakpoints.b560}px) {
    /* Tablet background image (560px to 1600px) */
    ${({ backgroundImages }) =>
      backgroundImages?.tablet &&
      `
        background-image: url('${backgroundImages.tablet}');
        background-color: transparent;
      `}
  }

  @media (min-width: ${Breakpoints.b960}px) {
    margin-bottom: 72px;
  }

  @media (min-width: ${Breakpoints.b1600}px) {
    width: calc(100vw - ${(theme: VWTheme) => theme?.size?.grid012 || '50vw'});
    height: 100vh;

    /* Desktop background image (1600px and above) */
    ${({ backgroundImages }) =>
      backgroundImages?.desktop &&
      `
        background-image: url('${backgroundImages.desktop}');
        background-color: transparent;
      `}
  }

  /* Loading state - show fallback color images are being processed */
  ${({ backgroundImages }) =>
    !backgroundImages &&
    `
      background-color: ${(theme: VWTheme) =>
        theme?.colors?.content?.tertiary || ' #3c484d'};
    `}
`;

export const StyledWelcomeContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  align-self: center;
  padding: 0px 32px 0px 32px;

  @media (min-width: ${Breakpoints.b560}px) {
    width: ${(theme: VWTheme) => theme?.size?.grid020 || '83.33vw'};
    padding: 0px ${(theme: VWTheme) => theme?.size?.grid002 || '8.33vw'} 0px
      ${(theme: VWTheme) => theme?.size?.grid002 || '8.33vw'};
  }

  @media (min-width: ${Breakpoints.b960}px) {
    width: ${(theme: VWTheme) => theme?.size?.grid012 || '50vw'};
    padding-left: unset;
    padding-right: unset;
    margin-bottom: calc(92px - 24px);
  }

  @media (min-width: ${Breakpoints.b1600}px) {
    width: ${(theme: VWTheme) => theme?.size?.grid008 || '33.33vw'};
    margin-left: ${(theme: VWTheme) => theme?.size?.grid001 || '8.33vw'};
    margin-right: ${(theme: VWTheme) => theme?.size?.grid001 || '8.33vw'};
    padding-left: unset;
    padding-right: unset;
    margin-bottom: 0;
  }
`;

export const StyledCTAWrapper = styled.div`
  margin-bottom: 20px;
  width: 100%;
`;

export const StyledTitleContainer = styled.div`
  text-align: center;
  color: ${(theme: VWTheme) =>
    theme?.colors?.content?.primary || ' #000e26'}; /* content-primary */
  margin-bottom: 12px;
`;

export const StyledTitleText = styled.span`
  font-size: 32px;
  font-weight: 400;
`;

export const StyledAppNameText = styled.span`
  font-size: 32px;
  font-weight: 700;
`;

export const StyledDescriptionContainer = styled.div`
  color: ${(theme: VWTheme) =>
    theme?.colors?.content?.tertiary || ' #3c484d'}; /* content-tertiary */
  text-align: center;
  margin-bottom: 40px;
`;

export const StyledSignUpContainer = styled.div`
  color: ${(theme: VWTheme) =>
    theme?.colors?.content?.tertiary || ' #3c484d'}; /* content-tertiary */
`;
